exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app_content .success[data-v-55f6801f]{background-color:var(--greenb2b);padding:50px 0}#app_content .success h1[data-v-55f6801f]{font-size:48px}", ""]);

// exports
